//@ts-nocheck
import { Box, ColorOptions, Icon, Spacer, Text } from '@jfs/ui-new'
import { convertHexToRGBA } from '@jfs/ui-new/src/utils/utils'
import { useStores } from '../../../data/store'

export const TipsInfoMobile = () => {
  const { theme } = useStores((root) => ({
    theme: root?.config?.merchantTheme,
  }))
  return (
    <Box
      p={18}
      width={'100%'}
      backgroundColor={convertHexToRGBA(theme?.brandColor, 10) as ColorOptions}
      flexDirection="row"
      alignItems="center">
      <Icon id="EXCLAMATION" size={16} color={theme?.bodyTextColor as ColorOptions} />
      <Spacer size={12} direction="horizontal" />
      <Text color={theme?.bodyTextColor as ColorOptions} fontSize={12} fontFamily="jioType-medium">
        {'Please do not press back button until payment is completed'}
      </Text>
    </Box>
  )
}
